import React, { useEffect, useState } from "react";
import { lifestyleApi } from "../apiService/api";
import { getUrlParams } from "../apiService/timespam";
import { FaCaretDown } from "react-icons/fa";

const shimmerStyle = `
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
`;
const styleSheet = document.createElement("style");
styleSheet.innerText = shimmerStyle;
document.head.appendChild(styleSheet);


const ShimmerAgeCard = () => {
    const shimmerBg = {
        background: "linear-gradient(90deg, var(--shimmer-1) 0%, var(--shimmer-2) 50%, var(--shimmer-1) 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
    };

    return (
        <div
            style={{
                width: "100%",
                backgroundColor: "var(--bg-card)",
                borderRadius: "20px",
                border: "1px solid var(--border-subtle)",
                padding: 15,
                paddingBottom: 20,
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >

            <div
                style={{
                    height: 20,
                    width: "40%",
                    margin: "0 auto 10px auto",
                    borderRadius: 8,
                    ...shimmerBg,
                }}
            />

            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                <div
                    style={{
                        width: 52,
                        height: 52,
                        borderRadius: "50%",
                        ...shimmerBg,
                    }}
                />
                <div style={{ flex: 1 }}>
                    <div
                        style={{
                            height: 55,
                            width: "100%",
                            borderRadius: 50,
                            ...shimmerBg,
                        }}
                    />
                </div>
            </div>

            {/* ---- bottom age ---- */}
            <div
                style={{
                    height: 18,
                    width: "30%",
                    margin: "20px auto 0",
                    borderRadius: 6,
                    ...shimmerBg,
                }}
            />
        </div>
    );
};

const Agecard = () => {
    const [ageData, setAgeData] = useState(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const { encryptedId } = getUrlParams();

        lifestyleApi.agecardData(encryptedId).then((res) => {
            if (res?.data?.code === 200) {
                setAgeData(res.data.data);
            }
        });
    }, []);

    const isMobile = windowSize.width <= 768;
    const isTablet = windowSize.width > 768 && windowSize.width <= 1024;

    const getResponsiveValue = (mobile, tablet, desktop) => {
        if (isMobile) return mobile;
        if (isTablet) return tablet;
        return desktop;
    };

    if (!ageData) return <ShimmerAgeCard />;

    return (
        <div
            style={{
                width: "100%",
                backgroundColor: "var(--bg-card)",
                backgroundSize: "cover",
                borderRadius: "20px",
                border: "1px solid var(--border-subtle)",
                paddingBottom: getResponsiveValue(20, 25, 25),
                paddingInline: getResponsiveValue(10, 15, 20),
                paddingTop: 15,
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >
            {/* daysdifference + agetext */}
            <div
                style={{
                    textAlign: "center",
                    marginTop: 0,
                    marginBottom: getResponsiveValue(8, 12, 15),
                    fontWeight: 600,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: getResponsiveValue(4, 5, 6),
                }}
            >
                <FaCaretDown
                    size={getResponsiveValue(16, 18, 20)}
                    color="#32A852"
                />
                <span
                    style={{
                        color: "#32A852",
                        fontSize: getResponsiveValue("12px", "18px", "19px"),
                        fontWeight: 700,
                        marginRight: getResponsiveValue(4, 5, 6),
                    }}
                >
                    {ageData.daysdifference}
                </span>
                <span
                    style={{
                        color: "var(--text-primary)",
                        fontSize: getResponsiveValue("11px", "13px", "14px"),
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                    }}
                >
                    {ageData.agetext}
                </span>
            </div>

            {/* avatar & slider bar */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: getResponsiveValue(10, 15, 20),
                    position: "relative",
                    marginTop: getResponsiveValue(8, 10, 10),
                }}
            >
                <img
                    src={ageData.userimage}
                    alt="user"
                    style={{
                        width: getResponsiveValue(48, 48, 52),
                        height: getResponsiveValue(50, 50, 55),
                        borderRadius: "50%",
                        border: "3px solid var(--bg-surface)",
                        flexShrink: 0,
                        zIndex: 10002,
                    }}
                />

                <div
                    style={{
                        flex: 1,
                        position: "relative",
                        marginRight: getResponsiveValue(20, 30, 40),
                    }}
                >
                    <div
                        style={{
                            height: getResponsiveValue(20, 45, 55),
                            borderRadius: 50,
                            background:
                                "linear-gradient(90deg, #37A845 0%, #B39752 50%, #E45A4E 100%)",
                            display: "flex",
                            alignItems: "center",
                            paddingInline: getResponsiveValue(8, 10, 10),
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                height: getResponsiveValue(4, 12, 14),
                                width: "100%",
                                background: "var(--bg-surface)",
                                borderRadius: 14,
                            }}
                        />
                    </div>

                    {/* pointer triangle */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: getResponsiveValue(3, 18, 18),
                            left: getResponsiveValue("25%", "20%", "20%"),
                            transform: "translateX(-50%)",
                            width: 0,
                            height: 0,
                            borderLeft: `${getResponsiveValue(6, 7, 8)}px solid transparent`,
                            borderRight: `${getResponsiveValue(6, 7, 8)}px solid transparent`,
                            borderBottom: `${getResponsiveValue(8, 9, 10)}px solid var(--text-primary)`,
                            zIndex: 10001,
                        }}
                    />

                    {/* bio age box */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: getResponsiveValue(-10, -6, -6),
                            left: getResponsiveValue("25%", "20%", "20%"),
                            transform: "translateX(-50%)",
                            background: "var(--text-primary)",
                            padding: getResponsiveValue("3px 10px", "4px 12px", "4px 13px"),
                            borderRadius: 16,
                            color: "var(--bg-surface)",
                            fontSize: getResponsiveValue(7, 13, 14),
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            zIndex: 9999,
                        }}
                    >
                        {ageData.bioage}
                    </div>

                    {/* left pointer circle */}
                    <div
                        style={{
                            position: "absolute",
                            top: getResponsiveValue(2, 16, 19),
                            left: getResponsiveValue("25%", "20%", "20%"),
                            transform: "translateX(-50%)",
                            width: getResponsiveValue(10, 12, 14),
                            height: getResponsiveValue(10, 12, 14),
                            borderRadius: "50%",
                            background: "#37A845",
                            border: "2px solid var(--bg-surface)",
                            zIndex: 10000,
                        }}
                    />

                    {/* middle pointer */}
                    <div
                        style={{
                            position: "absolute",
                            top: getResponsiveValue(6, 16, 18),
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: 0,
                            height: 0,
                            borderLeft: `${getResponsiveValue(7, 11, 12)}px solid transparent`,
                            borderRight: `${getResponsiveValue(7, 11, 12)}px solid transparent`,
                            borderBottom: `${getResponsiveValue(10, 16, 18)}px solid #B39752`,
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            top: getResponsiveValue(15, 26, 31),
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: getResponsiveValue(2, 3, 4),
                            height: getResponsiveValue(20, 38, 46),
                            background: "#B39752",
                        }}
                    />
                </div>
            </div>

            {/* bottom age */}
            <div
                style={{
                    marginTop: getResponsiveValue(0, 32, 35),
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                    fontSize: getResponsiveValue(12, 14, 15),
                    fontWeight: 600,
                    paddingLeft: getResponsiveValue(40, 40, 40),
                    color: "var(--text-primary)",
                }}
            >
                {ageData.actualage}
            </div>
        </div>
    );
};

export default Agecard;
